import {ReactNode} from "react";
import {css, cx} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {Text} from "@pg-design/text-module";

type PricesHubTrendChipSize = "default" | "compact" | "large";

interface IProps {
    isBelow: boolean;
    children: ReactNode;
    hiddenLabel?: string;
    size?: PricesHubTrendChipSize;
    className?: string;
}

const getChipStyle = (size: PricesHubTrendChipSize, isBelow: boolean) => {
    if (size === "compact") {
        return isBelow ? compactBelowStyle : compactAboveStyle;
    }

    if (size === "large") {
        return isBelow ? largeBelowStyle : largeAboveStyle;
    }

    return isBelow ? defaultBelowStyle : defaultAboveStyle;
};

const getChipVariant = (size: PricesHubTrendChipSize) => {
    if (size === "compact") {
        return "info_txt_1" as const;
    }

    return size === "large" ? ("button_small" as const) : ("button_micro" as const);
};

export const PricesHubTrendChip = (props: IProps) => {
    const {isBelow, children, hiddenLabel, size = "default", className} = props;

    return (
        <Text as="span" variant={getChipVariant(size)} preserveFontSize className={cx(getChipStyle(size, isBelow), className)}>
            {hiddenLabel ? <span className={visuallyHidden()}>{hiddenLabel} </span> : null}
            {children}
        </Text>
    );
};

const baseChipStyle = {
    position: "relative",
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    color: "var(--colors-secondary)",
    borderRadius: "999px",
    whiteSpace: "nowrap"
} as const;

const defaultChipStyle = {
    ...baseChipStyle,
    px: 1.5,
    py: "0.3rem"
} as const;

const compactChipStyle = {
    ...baseChipStyle,
    px: "0.6rem",
    py: "0.2rem"
} as const;

const largeChipStyle = {
    ...baseChipStyle,
    px: "1.4rem",
    py: "0.4rem"
} as const;

const defaultBelowStyle = css({
    ...defaultChipStyle,
    backgroundColor: "var(--colors-success)"
});

const defaultAboveStyle = css({
    ...defaultChipStyle,
    backgroundColor: "var(--colors-warning)"
});

const compactBelowStyle = css({
    ...compactChipStyle,
    backgroundColor: "var(--colors-success)"
});

const compactAboveStyle = css({
    ...compactChipStyle,
    backgroundColor: "var(--colors-warning)"
});

const largeBelowStyle = css({
    ...largeChipStyle,
    backgroundColor: "var(--colors-success)"
});

const largeAboveStyle = css({
    ...largeChipStyle,
    backgroundColor: "var(--colors-warning)"
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";
import {visuallyHidden} from "@panda/patterns";

import {Text} from "@pg-design/text-module";

type PricesHubTrendChipSize = "default" | "compact" | "large";

interface IProps {
    isBelow: boolean;
    children: ReactNode;
    hiddenLabel?: string;
    size?: PricesHubTrendChipSize;
    className?: string;
}

const getChipStyle = (size: PricesHubTrendChipSize, isBelow: boolean) => {
    if (size === "compact") {
        return isBelow ? compactBelowStyle : compactAboveStyle;
    }

    if (size === "large") {
        return isBelow ? largeBelowStyle : largeAboveStyle;
    }

    return isBelow ? defaultBelowStyle : defaultAboveStyle;
};

const getChipVariant = (size: PricesHubTrendChipSize) => {
    if (size === "compact") {
        return "info_txt_1" as const;
    }

    return size === "large" ? ("button_small" as const) : ("button_micro" as const);
};

export const PricesHubTrendChip = (props: IProps) => {
    const {isBelow, children, hiddenLabel, size = "default", className} = props;

    return (
        <Text as="span" variant={getChipVariant(size)} preserveFontSize className={cx(getChipStyle(size, isBelow), className)}>
            {hiddenLabel ? <span className={visuallyHidden()}>{hiddenLabel} </span> : null}
            {children}
        </Text>
    );
};

const baseChipStyle = {
    position: "relative",
    display: "inline-flex",
    flex: "0 0 auto",
    alignItems: "center",
    color: "var(--colors-secondary)",
    borderRadius: "999px",
    whiteSpace: "nowrap"
} as const;

const defaultChipStyle = {
    ...baseChipStyle,
    px: 1.5,
    py: "0.3rem"
} as const;

const compactChipStyle = {
    ...baseChipStyle,
    px: "0.6rem",
    py: "0.2rem"
} as const;

const largeChipStyle = {
    ...baseChipStyle,
    px: "1.4rem",
    py: "0.4rem"
} as const;

const defaultBelowStyle = css({
    ...defaultChipStyle,
    backgroundColor: "var(--colors-success)"
});

const defaultAboveStyle = css({
    ...defaultChipStyle,
    backgroundColor: "var(--colors-warning)"
});

const compactBelowStyle = css({
    ...compactChipStyle,
    backgroundColor: "var(--colors-success)"
});

const compactAboveStyle = css({
    ...compactChipStyle,
    backgroundColor: "var(--colors-warning)"
});

const largeBelowStyle = css({
    ...largeChipStyle,
    backgroundColor: "var(--colors-success)"
});

const largeAboveStyle = css({
    ...largeChipStyle,
    backgroundColor: "var(--colors-warning)"
});
